module.exports = __webpack_public_path__ + "img/w6_feature_02.de9b2780.jpg";